import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function MayaSolution({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    maya_solution: false,
  });

  // Maya Solution options
  const MAYA_SOLUTION_OPTIONS = [
    "SQR",
    "Terminal",
    "SQR & Terminal",
    "Online"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      maya_solution: !primaryDetails.maya_solution,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select a Maya solution", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const [terminalDetails, setTerminalDetails] = useState({
    terminal_available: '',
    terminal_device_count: '',
    terminal_model: [],
    terminal_mid_card: '',
    terminal_mid_qr: '',
    reason_no_mid: [],
    other_reason_no_mid: '',
    has_defective_terminal: '',
  });
  const [terminalError, setTerminalError] = useState({});

  const TERMINAL_MODELS = ['SUNMI', 'A920', 'A50'];
  const REASON_NO_MID = [
    'Needs management approval first',
    'HO restriction',
    'Data privacy',
    'Defective terminal',
    'Other reason',
  ];

  const handleTerminalChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      if (name === 'terminal_model') {
        setTerminalDetails((prev) => ({
          ...prev,
          terminal_model: checked
            ? [...prev.terminal_model, value]
            : prev.terminal_model.filter((v) => v !== value),
        }));
      } else if (name === 'reason_no_mid') {
        setTerminalDetails((prev) => ({
          ...prev,
          reason_no_mid: checked
            ? [...prev.reason_no_mid, value]
            : prev.reason_no_mid.filter((v) => v !== value),
        }));
      }
    } else {
      setTerminalDetails((prev) => ({ ...prev, [name]: value }));
    }
    if (terminalError[name]) {
      setTerminalError((prev) => ({ ...prev, [name]: false }));
    }
  };


  // SQR Section State
  const [sqrDetails, setSqrDetails] = useState({
    sqr_store_codes: '',
    sqr_reason_no_code: '',
    sqr_other_reason: '',
    sqr_location: '',
    sqr_count: '',
  });
  const [sqrError, setSqrError] = useState({});

  const SQR_REASON_NO_CODE = [
    'old design - green bird',
    'old design - 1.5',
    'damaged standee',
    'misplaced',
    'other reason',
  ];
  const SQR_LOCATIONS = ['beside cashier', 'others'];

  const handleSqrChange = (e) => {
    const { name, value } = e.target;
    setSqrDetails((prev) => ({ ...prev, [name]: value }));
    if (sqrError[name]) {
      setSqrError((prev) => ({ ...prev, [name]: false }));
    }
  };

  // Updated SQR Section State
  const [updatedSqr, setUpdatedSqr] = useState('');
  const [updatedSqrError, setUpdatedSqrError] = useState(false);

  const handleUpdatedSqrChange = (e) => {
    setUpdatedSqr(e.target.value);
    if (updatedSqrError) setUpdatedSqrError(false);
  };

  // Updated SQR validation to require updatedSqr if a reason is selected
  const validateSqrSection = () => {
    if (primaryDetails.maya_solution !== 'SQR') return true;
    const errors = {
      sqr_store_codes: !sqrDetails.sqr_store_codes,
      sqr_reason_no_code: !sqrDetails.sqr_reason_no_code,
      sqr_other_reason:
        sqrDetails.sqr_reason_no_code === 'other reason' && !sqrDetails.sqr_other_reason,
      sqr_location: !sqrDetails.sqr_location,
      sqr_count: !sqrDetails.sqr_count,
    };
    setSqrError(errors);
    let hasErrors = Object.values(errors).some((e) => e);
    // If a reason is selected, require updatedSqr
    if (sqrDetails.sqr_reason_no_code && !updatedSqr) {
      setUpdatedSqrError(true);
      hasErrors = true;
    }
    if (hasErrors) {
      toast.error('Please fill in all required SQR solution details', {
        autoClose: 3000,
        hideProgressBar: true,
        theme: 'colored',
      });
      return false;
    }
    return true;
  };

  // Defective Terminal Section State
  const [defectiveDetails, setDefectiveDetails] = useState({
    defective_count: '',
    defective_terminal_ids: '',
    defective_serial_nos: '',
    escalation_case_no: '',
  });
  const [defectiveError, setDefectiveError] = useState({});

  const handleDefectiveChange = (e) => {
    const { name, value } = e.target;
    setDefectiveDetails((prev) => ({ ...prev, [name]: value }));
    if (defectiveError[name]) {
      setDefectiveError((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validateDefectiveSection = () => {
    if (!(primaryDetails.maya_solution === 'Terminal' || primaryDetails.maya_solution === 'SQR & Terminal')) return true;
    if (terminalDetails.has_defective_terminal !== 'Yes') return true;
    const errors = {
      defective_count: !defectiveDetails.defective_count,
      defective_terminal_ids: !defectiveDetails.defective_terminal_ids,
      defective_serial_nos: !defectiveDetails.defective_serial_nos,
    };
    setDefectiveError(errors);
    const hasErrors = Object.values(errors).some((e) => e);
    if (hasErrors) {
      toast.error('Please fill in all required defective terminal details', {
        autoClose: 3000,
        hideProgressBar: true,
        theme: 'colored',
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.maya_solution;
  };
  // Handle next button click with proper routing logic
  const handleNext = () => {
    if (!validateForm()) return;
    
    if (primaryDetails.maya_solution === 'SQR') {
      navigation.go('maya-sqr-solution-details');
    } else if (primaryDetails.maya_solution === 'Online') {
      navigation.go("terminal-availability");
    } 
    // } else if (primaryDetails.maya_solution === 'Terminal' || primaryDetails.maya_solution === 'SQR & Terminal') {
    //   navigation.go('maya-terminal-solution-details');
    // }
    else {
      navigation.go('maya-terminal-solution-details'); // Default fallback
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">MAYA SOLUTION</h4>
                <p className="form-desc">Please select the type of Maya solution for this merchant</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Maya Solution Question */}
                  <Form.Group className="mb-5" controlId="maya_solution">
                    <Form.Label className="form-label">
                      Maya Solution <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {MAYA_SOLUTION_OPTIONS.map((option, index) => (
                        <div
                          key={`maya-solution-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.maya_solution === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            {/* <div className="form-radio-index">
                              {String(index + 1).padStart(2, '0')}
                            </div> */}
                            <Form.Check
                              type="radio"
                              name="maya_solution"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.maya_solution === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.maya_solution && (
                      <div className="form-error">
                        Please select a Maya solution
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back 
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaSolution;
